import { IntercomProviderUser } from '@cld/intercom';
import { User, UserRole } from '@cld/application-wrapper-common';

export const getUserDataAsIntercomUser = (userData?: User) => {
  return (
    userData?.userInfo &&
    ({
      name: userData.userInfo.name,
      email: userData.userInfo.email,
      external_id: userData.externalId,
      external_account_id: userData.userInfo.accountId,
      created_at: userData.createdAt,
      account_id: userData.userInfo.accountId,
      intercom_hash: userData.intercomHash,
      plan_name: userData.planInfos[0]?.plan_name,
      technical_role: userData.technicalRole,
      technical_role_details: userData.technicalRoleDetails,
      main_goals: userData.mainGoals === null ? null : typeof userData.mainGoals === 'string' ? userData.mainGoals : userData.mainGoals.join(','),
      main_goals_details: userData.mainGoalsDetails,
      role: userData.role,
    } as IntercomProviderUser)
  );
};

export const isAnyTypeOfAdmin = (userData?: User): boolean => userData?.isAdmin || userData?.isMasterAdmin || userData?.role === UserRole.TechnicalAdmin;
